import React, { useEffect, useContext } from 'react'
import { VStack, Heading, Text, Box, useColorMode } from '@chakra-ui/react'
import { getTokens } from '../config/colorTokens'
import { motion, AnimatePresence } from 'framer-motion'
import Section from '../components/Section'
import Volunteer from '../components/Volunteer/Volunteer'
import { volunteering } from '../data/volunteering'
import Loader from '../components/Loader/Loader'
import loaderContext from '../context/loaderContext'
import SEOHead from "../components/SEOHead";
import { pageVariants, containerVariants, itemVariants, heroVariants } from '../config/animations'

const MotionVStack = motion(VStack)
const MotionBox = motion(Box)

const Volunteering = () => {
    const context = useContext(loaderContext)
    const { loading, setLoading } = context
    const { colorMode } = useColorMode()
    const t = getTokens(colorMode)

    useEffect(() => {
        setTimeout(() => {
            setLoading(false)
        }, 1500)
    }, [setLoading])
    return (
        <div>
            <SEOHead 
                title="Volunteering | Prasoon Soni"
                description="Community service and volunteering activities of Prasoon Soni - Giving back through technology education, mentorship, and community involvement."
                path="/volunteering"
            />
            <AnimatePresence>
                {loading ? <Loader key="loader" /> : <MotionVStack
                    key="content"
                    variants={pageVariants}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                    spacing={0}
                    w="100%"
                    minH="100vh"
                >
                <Section id="volunteering">
                    <VStack align="stretch" spacing={4} p={4}>
                        <MotionBox variants={heroVariants}>
                            <VStack align="start" spacing={3} mb={4}>
                                <Heading w="full">Volunteering</Heading>
                                <Text
                                    fontSize={{ base: "md", md: "lg" }}
                                    color={t.textSubtle}
                                    fontWeight="light"
                                    maxW="2xl"
                                >
                                    Using technology to empower communities.
                                </Text>
                                <Box
                                    h="2px"
                                    w="60px"
                                    bgGradient={t.accentGradient}
                                    borderRadius="full"
                                    mt={1}
                                />
                            </VStack>
                        </MotionBox>
                        <MotionVStack
                            align="stretch"
                            spacing={4}
                            variants={containerVariants}
                        >
                            {volunteering.map((exp) => {
                                return (
                                    <Volunteer
                                        key={exp.id}
                                        role={exp.role}
                                        company={exp.company}
                                        type={exp.type}
                                        location={exp.location}
                                        logo={exp.logo}
                                        date={exp.date}
                                        description={exp.description}
                                        variants={itemVariants}
                                    />
                                )
                            })}
                        </MotionVStack>
                    </VStack>
                </Section>
                </MotionVStack>}
            </AnimatePresence>
        </div >
    )
}

export default Volunteering
